export default function ClientEnrollmentStatus({ status, testid }) {
  const ok = status === "confermata";
  return (
    <span data-testid={testid}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wide ${ok ? "bg-emerald-100 text-emerald-800" : "bg-red-100 text-red-700"}`}>
      {ok ? "Confermata" : "Annullata"}
    </span>
  );
}
